export default "__VITE_ASSET__72yDbDKa__"